import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { AuthContext } from './AuthContext';

export const PlatformSettingsContext = createContext();

// Everything visible is the safe fallback while loading or if the lookup
// ever fails — never lock a seller out of the whole app because one request
// didn't come back.
const FALLBACK_VISIBILITY = {
  dashboard: true, products: true, orders: true, listings: true,
  inventory: true, catalog: true, reports: true
};

export const PlatformSettingsProvider = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const [navVisibility, setNavVisibility] = useState(FALLBACK_VISIBILITY);
  const [loading, setLoading] = useState(true);

  const fetchVisibility = useCallback(async () => {
    if (!isAuthenticated) {
      setNavVisibility(FALLBACK_VISIBILITY);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const response = await api.get('/admin/nav-visibility');
      setNavVisibility(response.data.navVisibility);
    } catch (err) {
      setNavVisibility(FALLBACK_VISIBILITY);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => { fetchVisibility(); }, [fetchVisibility]);

  return (
    <PlatformSettingsContext.Provider value={{ navVisibility, loading, refetch: fetchVisibility }}>
      {children}
    </PlatformSettingsContext.Provider>
  );
};
